import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=7479269f&scoped=true&lang=pug"
import script from "./ModalNotification.vue?vue&type=script&lang=ts"
export * from "./ModalNotification.vue?vue&type=script&lang=ts"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=7479269f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479269f",
  null
  
)

export default component.exports